function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28 16v8H8v32h32V36h8v24a4 4 0 01-4 4H4a4 4 0 01-4-4V20a4 4 0 014-4h24zM58 4a2 2 0 012 2v18a4 4 0 11-8 0v-6.344L22.857 46.799a4 4 0 01-5.657-5.657L46.342 12H40a4 4 0 110-8h18z",
  fill: "currentColor",
  fillRule: "evenodd"
})));